"use strict";

//  SCSS
import "../scss/style.scss";

// JS
import axios from 'axios';

import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import lightbox from 'alpine-tailwind-lightbox';

import offcanvas from "./modules/offcanvas";
import accordionItem from "./modules/accordionItem";
//import contactForm from "./modules/contactForm";

Alpine.plugin(focus);
Alpine.plugin(lightbox);

window.Alpine = Alpine;

Alpine.data('offcanvas', offcanvas);
Alpine.data('accordionItem', accordionItem);
//Alpine.data('contactForm', contactForm);

Alpine.start();

window.axios = axios;